import React, { useCallback, useState } from 'react';
import { useCurrentOrganization } from 'src/store/organization';
import { Nullable } from 'src/types/nullable.type';
import { apiGetProspectLogo } from 'src/utils/journeyApi';
import { formatUrl } from 'src/utils/url';

type ClearbitStatus = 'success' | 'error' | null;

export const useProspectLogo = () => {
  const [status, setStatus] = useState<ClearbitStatus>(null);
  const [fetching, setFetching] = useState(false);
  const [logoUrl, setLogoUrl] = useState<Nullable<string>>();
  const [generatedSlug, setGeneratedSlug] = useState<Nullable<string>>();
  const [domain, setDomain] = useState<Nullable<string>>();
  const currentOrganization = useCurrentOrganization((state) => state.currentOrganization);

  const fetchProspectLogo = useCallback(
    async (url: string) => {
      try {
        setStatus(null);
        setFetching(true);
        setLogoUrl(null);
        setGeneratedSlug(null);
        setDomain(null);
        const formattedUrl = formatUrl(url);
        const domain = new URL(formattedUrl).hostname;

        const prospectLogoResponse = await apiGetProspectLogo(domain, currentOrganization.slug);
        setLogoUrl(prospectLogoResponse.logo_url);
        setGeneratedSlug(prospectLogoResponse.generated_slug);
        setDomain(prospectLogoResponse.domain);
        setStatus('success');
        setFetching(false);
      } catch (error: any) {
        setStatus('error');
        setFetching(false);
      }
    },
    [currentOrganization.slug]
  );

  return {
    fetchProspectLogo,
    status,
    fetching,
    logoUrl,
    setLogoUrl,
    generatedSlug,
    setGeneratedSlug,
    domain,
    setDomain,
  };
};
